import { FC } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import dayjs from 'dayjs';
import { useTranslation } from '@frontend/i18n';
import { InlineNotification } from '@frontend/design-system';
import { OFFICE_HOURS_FILTER_SUPPORT_DATE } from '../../constants';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';

const formattedSupportDate = dayjs(OFFICE_HOURS_FILTER_SUPPORT_DATE).format('MMMM D, YYYY');

type OfficeHoursResetBannerProps = {
  customStyles?: Interpolation<Theme>;
};

export const OfficeHoursResetBanner: FC<OfficeHoursResetBannerProps> = ({ customStyles }) => {
  const { t } = useTranslation('call-intelligence');
  const { autoResetFilters } = useCallIntelFiltersContext();

  if (!autoResetFilters.officeHours) {
    return null;
  }

  return (
    <InlineNotification
      status='info'
      size='medium'
      message={t(
        'The Office Hours filter was removed. Office Hours filtering is only available for calls starting {{date}}.',
        { date: formattedSupportDate }
      )}
      customStyles={[styles.wrapper, customStyles]}
    />
  );
};

const styles = {
  wrapper: css`
    max-width: 100%;
    max-height: none;
    p {
      white-space: wrap;
    }
  `,
};
